/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query";
import type {
  PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsOpenCancelledMutationRequest,
  PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsOpenCancelledMutationResponse,
  PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsOpenCancelledPathParams,
  PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsOpenCancelled401,
  PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsOpenCancelled500,
} from "../../types/individualPaymentOperationsController/PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsOpenCancelled.ts";
import { mutationOptions, useMutation } from "@tanstack/react-query";
import { postApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsOpenCancelled } from "../../clients/individualPaymentOperationsController/postApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsOpenCancelled.ts";

export const postApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsOpenCancelledMutationKey =
  () =>
    [
      {
        url: "/api/v1/individualpayment/financial-people/:financialPersonId/parcels/open-cancelled",
      },
    ] as const;

export type PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsOpenCancelledMutationKey =
  ReturnType<
    typeof postApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsOpenCancelledMutationKey
  >;

export function postApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsOpenCancelledMutationOptions<
  TContext = unknown,
>(
  config: Partial<
    RequestConfig<PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsOpenCancelledMutationRequest>
  > & { client?: Client } = {},
) {
  const mutationKey =
    postApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsOpenCancelledMutationKey();
  return mutationOptions<
    PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsOpenCancelledMutationResponse,
    ResponseErrorConfig<
      | PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsOpenCancelled401
      | PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsOpenCancelled500
    >,
    {
      financialPersonId: PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsOpenCancelledPathParams["financialPersonId"];
      data?: PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsOpenCancelledMutationRequest;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ financialPersonId, data }) => {
      return postApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsOpenCancelled(
        financialPersonId,
        data,
        config,
      );
    },
  });
}

/**
 * @description Migrado do legado IndividualPayment/OpenCancelParcels. **(Requer Authorization para autenticação)**
 * @summary Reabre parcelas canceladas do plano como pendentes (Requer Authorization para autenticação)
 * {@link /api/v1/individualpayment/financial-people/:financialPersonId/parcels/open-cancelled}
 */
export function usePostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsOpenCancelled<
  TContext,
>(
  options: {
    mutation?: UseMutationOptions<
      PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsOpenCancelledMutationResponse,
      ResponseErrorConfig<
        | PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsOpenCancelled401
        | PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsOpenCancelled500
      >,
      {
        financialPersonId: PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsOpenCancelledPathParams["financialPersonId"];
        data?: PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsOpenCancelledMutationRequest;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<
      RequestConfig<PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsOpenCancelledMutationRequest>
    > & { client?: Client };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    postApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsOpenCancelledMutationKey();

  const baseOptions =
    postApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsOpenCancelledMutationOptions(
      config,
    ) as UseMutationOptions<
      PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsOpenCancelledMutationResponse,
      ResponseErrorConfig<
        | PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsOpenCancelled401
        | PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsOpenCancelled500
      >,
      {
        financialPersonId: PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsOpenCancelledPathParams["financialPersonId"];
        data?: PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsOpenCancelledMutationRequest;
      },
      TContext
    >;

  return useMutation<
    PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsOpenCancelledMutationResponse,
    ResponseErrorConfig<
      | PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsOpenCancelled401
      | PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsOpenCancelled500
    >,
    {
      financialPersonId: PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsOpenCancelledPathParams["financialPersonId"];
      data?: PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsOpenCancelledMutationRequest;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsOpenCancelledMutationResponse,
    ResponseErrorConfig<
      | PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsOpenCancelled401
      | PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsOpenCancelled500
    >,
    {
      financialPersonId: PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsOpenCancelledPathParams["financialPersonId"];
      data?: PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsOpenCancelledMutationRequest;
    },
    TContext
  >;
}
